module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Return_of_the_Raven_Mocker2#Contents-A"
    }
  }, [_vm._v("Cast of Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Alafair Tucker—Takes care of everyone even if they don’t ask")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Shaw Tucker—Her husband, in charge of everything, more or less")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level1"
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("Their children")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "cast-level2"
  }, [_vm._v("Martha McCoy—age 27, President of Boynton Red Cross Chapter")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Major Streeter McCoy—her husband, in Washington D.C., winning the war")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Mary Lucas—age 25, keeping quarantine")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Sergeant Kurt Lucas—her husband, in Washington D.C., translating German documents")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Judy Lucas—age 33 months, their daughter")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Alice Kelley—age 24, feeling poorly")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Walter Kelley—her husband, also feeling poorly")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Linda Kelley—age 27 months, their daughter")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Phoebe Day—age 24, Alice’s twin, taking care of her father")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("John Lee Day—her husband, running the farm")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Zeltha Day—age 4, their daughter")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Tucker Day—age 26 months, their son")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Lt. George W. Tucker, also known as Gee Dub—age 22, in France")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Ruth Tucker—age 19, taking care of her mentor")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level3"
  }, [_vm._v("Seaman Trenton Calder, Ruth’s intended, somewhere in the North Atlantic")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Private Charlie Tucker—age 17, driving trucks in England, whether he ought to be or not")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Blanche Tucker—age 13, wrangling babies")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Sophronia Tucker—age 12, causing trouble")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Grace Tucker—age 6, or close enough to make no difference")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level4"
  }, [_vm._v("Members of the family:")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level2"
  }, [_vm._v("Chase Kemp—age 8, Alafair’s nephew and ward, a talented spy")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Scott Tucker—the law in Boynton, Oklahoma, Shaw’s cousin")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Hattie Tucker—Scott’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Slim Tucker—their son, Scott’s deputy")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level4"
  }, [_vm._v("No relation, but God’s children all the same:")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level2"
  }, [_vm._v("Wesley M. Cotton—prosecuting attorney, District Court of Muskogee County")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Doctor Emmett Carney—doing the best he can against long odds")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Ann Addison (Mrs. Doc)—the local midwife, pressed into service")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Nola Thomason—Alice’s neighbor")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Homer Thomason—Nola’s husband")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Dorothy Thomason—their daughter, Sophronia’s friend")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Lewis Hulce—Nola’s son from a previous marriage")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("JoNell Reed—Lewis’ beloved")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Mrs. Gale—Alice’s neighbor")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Old Man Escoe—Mrs. Gale’s father, loves cats and children")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level2"
  }, [_vm._v("Sweet Honey Baby—a horse often involved in criminal activity")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("Bacon, Charlie Dog, Big Fella, Buttercup, Crook—the family dogs")]), _vm._v(" "), _c('p', {
    staticClass: "cast-level"
  }, [_vm._v("A half-grown yellow kitten—may be magic")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04faa7ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Return_of_the_Raven_Mocker-3.vue
// module id = 69
// module chunks = 0